import { css } from 'styled-components';
import { grey400, white } from '../../../../../colors/greyscale';
import { disabledStyle } from '../../../../../utils/style';

export const alertDisabledStyles = disabledStyle(css`
  background-color: ${grey400};
  border-color: ${grey400};
  color: ${white};
`);
